import React from 'react'
import { Button } from 'loyal-react'
import PropTypes from 'prop-types'
import { StixStars } from './'

const SideBar = ({
  loadingPayment,
  disabledButton = true,
  partnerName = 'Ponto Frio',
  creditValue = 0,
  starValue = 0,
  handlerFinalizePayment = () => {}
}) => {
  return (
    <div className='cart-side col-12 mt-3 mt-md-0 border-ui-3 radius bg-white px-0 py-0'>
      <div className='col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'>
        <h3 className='color-title txt-font-body'>Resumo do resgate</h3>
      </div>
      <div className='cart-subtotal col-12 pb-3 mx-0'>
        <div className='row product-brand bg-ui-5 py-2  px-2  border-dotted-bottom border-color-ui-3'>
          <div className='col-9  txt-left  justify-content-center align-self-center'>
            <p className='txt-body-sm txt-font-body color-ui-2'>
              Transferência: <strong>{partnerName}</strong>
            </p>
            <p className='txt-body-sm  txt-font-body color-ui-2'>
              Valor em pontos:{' '}
              <strong> {creditValue === '' ? 0 : creditValue} </strong>
            </p>
            <p className='txt-body-sm txt-font-body color-ui-2'>
              Quantidade:{' '}
              <StixStars totalStars={starValue} />
            </p>
          </div>
        </div>
        <div className='row product-brand pt-3  px-2'>
          <div className='col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '>
            <p className='txt-subtitle txt-font-body color-ui-2' data-partnername={partnerName}>
              Ao clicar em finalizar transferência, seus pontos serão
              transferidos para o Grupo Pão de Açúcar.
            </p>
          </div>
        </div>
        <div className='cart-done row  px-2 pt-2 '>
          <div className='col-12 justify-content-center align-self-center'>
            {loadingPayment ? (
              <button
                className='btn-featured btn-icon'
                aria-label='Carregando...'
                disabled={disabledButton}
              >
                <div className='btn-loading mr-auto ml-auto'>
                  <div />
                  <div />
                  <div />
                  <div />
                </div>
              </button>
            ) : (
              <Button
                className='btn-featured btn-icon'
                disabled={disabledButton}
                text='Finalizar Transferência'
                iconName='icon_gift icon-sm'
                onClick={handlerFinalizePayment}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

SideBar.propTypes = {
  loadingPayment: PropTypes.bool,
  disabledButton: PropTypes.bool,
  partnerName: PropTypes.string,
  creditValue: PropTypes.number,
  starValue: PropTypes.number,
  handlerFinalizePayment: PropTypes.func
}
export default SideBar



// WEBPACK FOOTER //
// ./src/features/Stix/SideBar.js